import {
  getSurveyStatementKey,
  removeSurveyStatementKey,
  setSurveyBannerDismissed
} from 'utils/persistence'

import {
  ACTIVE_STATEMENT_KEYS,
  SURVEY_MESSAGES,
  SurveyQuestion,
  SurveyStatementKey
} from './constants'

const isActiveStatementKey = (value: string): value is SurveyStatementKey =>
  (ACTIVE_STATEMENT_KEYS as readonly string[]).includes(value)

const getRandomStatementKey = (): SurveyStatementKey =>
  ACTIVE_STATEMENT_KEYS[
    Math.floor(Math.random() * ACTIVE_STATEMENT_KEYS.length)
  ]

export const getQuestionByKey = (key: SurveyStatementKey): SurveyQuestion => ({
  questionId: key,
  statement: SURVEY_MESSAGES[key]
})

const restoreOrGetStatementKey = (): SurveyStatementKey => {
  const storedKey = getSurveyStatementKey()

  if (storedKey && isActiveStatementKey(storedKey)) {
    return storedKey
  }

  return getRandomStatementKey()
}

export const restoreOrGetQuestion = (): SurveyQuestion =>
  getQuestionByKey(restoreOrGetStatementKey())

export const persistDismissal = () => {
  setSurveyBannerDismissed()
  removeSurveyStatementKey()
}
